<div class="PremiumInfo">
    <!-- <div class="Loading"  *ngIf="isShowLoading==true">
                <img id="" src="assets/img/762.gif"   />
                <label>{{'Please Wait,Processing..'|translate }}</label>

        </div> -->


    <div class="Loading" *ngIf="isShowLoading==true">
        <div class="loader"></div>
        <!-- <img id="" src="assets/img/762.gif"   /> -->
        <label class="loaderlabel">Please wait while Processing....</label>
    </div>

    <div class="alert alert-danger" *ngIf="isError">
        <strong>{{ ErrorMsg }}</strong>
    </div>

    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="card" style="width:100%;" id="InsuredInfo">
            <ul class="nav nav-tabs listdata" role="tablist">
                <li role="presentation" class="active">
                    <a href="#home" aria-controls="home" role="tab" data-toggle="tab">
                        {{'Premium Details'| translate}}</a>
                </li>

            </ul>
            <div class="tab-content detailsTab">
                <div role="tabpanel" class="tab-pane active" id="home">

                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" *ngIf="(prObj.HasTPL && prObj.productType=='5515') || (prObj.HasTPL && prObj.productType=='0000') ">
                            <div class="PolicyPeriodInfo">

                                <div class="card" style="width:100%;">
                                    <ul class="nav nav-tabs Sublistdata" role="tablist">
                                        <li role="presentation" class="active">
                                            <a href="#home" aria-controls="home" role="tab" data-toggle="tab">
                                                {{'TPL Price in SAR' | translate }} </a>

                                        </li>

                                    </ul>
                                    <div class="tab-content">
                                        <div role="tabpanel" class="tab-pane active PolicyInfo Premium">
                                            <div class="CoversList">
                                                <label *ngFor="let tc of prObj.tplCovers | tplCoversPipe:true">
                                                    <span
                                                        class="lbltext">{{ Lng=="en"?tc.CoverDescription:tc.CoverDescription_Ar}}:</span>
                                                    <span>{{tc.GrossAmount | number : '1.2-2' }}</span>



                                                </label>

                                                <label>
                                                    <span class="lbltext"> {{'Gross Premium'| translate}}:</span>
                                                    <span>{{prObj.GrossPremium | number : '1.2-2'}}</span>

                                                </label>
                                                <label *ngIf="prObj.NCDPercentage>0">
                                                    <span class="lbltext"> {{'NCD'| translate}} :</span>
                                                    <span>{{prObj.NCDAmount | number : '1.2-2'}}({{prObj.NCDPercentage}}%)</span>

                                                </label>
                                                <label *ngIf="prObj.LDAmount>0">
                                                    <span class="lbltext"> {{'LD'| translate}}:</span>
                                                    <span>{{prObj.LDAmount | number : '1.2-2'}}({{prObj.LDPercentage}}%)</span>

                                                </label>
                                                <label *ngIf="prObj.CrossSellDiscount>0">
                                                    <span class="lbltext"> {{ 'CS Discount'| translate}}:</span>
                                                    <span>{{prObj.CrossSellDiscount | number : '1.2-2'}}({{prObj.CrossSellDisPercent}}%)</span>

                                                </label>
                                
                                                <label *ngIf="prObj.DriverDiscPer>0">
                                                    <span class="lbltext">
                                                        {{ 'Female Driver Discount'| translate}}:</span>
                                                    <span>{{prObj.DriverDiscAmount | number : '1.2-2'}}({{prObj.DriverDiscPer}}%)</span>

                                                </label>

                                                <label *ngIf="prObj.UserDiscountAmt>0">
                                                    <span class="lbltext"> {{'Scheme Discount'| translate}}:</span>
                                                    <span>{{prObj.UserDiscountAmt | number : '1.2-2'}}({{prObj.UserDiscountPer}}%)</span>

                                                </label>
                                                <label *ngIf="prObj.PromoDiscount>0">
                                                    <span class="lbltext"> {{ 'Promo Discount'| translate}}:</span>
                                                    <span>{{prObj.PromoDiscount | number : '1.2-2'}}({{prObj.PromoPercent}}%)</span>

                                                </label>
                                                <label>
                                                    <span class="lbltext"> {{'Total(Excluding VAT)'| translate}}:</span>
                                                    <span>{{prObj.TotalPremiumBeforeVAT | number : '1.2-2'}}</span>

                                                </label>

                                                <label>
                                                    <span class="lbltext"> {{'VAT'| translate}}:</span>
                                                    <span>{{prObj.VAT_AMOUNT | number : '1.2-2'}}({{prObj.VAT_PERCENT}}%)</span>

                                                </label>
                                                <label *ngIf="prObj.UPR_VAT_AMOUNT>0">
                                                    <span class="lbltext"> {{'UPR VAT'| translate}}:</span>
                                                    <span>{{prObj.UPR_VAT_AMOUNT | number : '1.2-2'}}</span>

                                                </label>
                                                <label *ngIf="prObj.SurplusAmount>0">
                                                    <span class="lbltext"> {{'Surplus Amount'| translate}}:</span>
                                                    <span>{{prObj.SurplusAmount | number : '1.2-2'}}</span>
                                                </label>
                                                <label class="Total">
                                                    <span> {{'Total'| translate}}:</span>
                                                    <span>{{prObj.TotalPremium | number : '1.2-2'}}</span>

                                                </label>
                                            </div>

                                            <div class="btncomprehensivediv">
                                                <button class="btn btn-primary" data-toggle="modal"
                                                    data-target="#AdditionalCoversModal"
                                                    [disabled]="prObj.isPromoApply==true">
                                                    {{'Add More Covers'| translate}}</button>
                                                <button class="btn btn-primary" name="btnTPLProceed" id="btnTPLProceed"
                                                    (click)="goForTPL()">{{'Purchase'| translate}}</button>

                                                    <!-- <button class="btn btn-primary" name="btnCompProceed"
                                                    id="btnCompProceed"
                                                    (click)="goForComprehensive()">{{'DownLoad Quote'| translate}}</button> -->
                                                    
                                                    <a href="{{url.PrintURL}}MOTOR/ProposalDL.aspx?strParm={{prObj.DownLoadProposal_Tpl}}:{{ProposalLan}}"
                                                    download="myPolicy"
                                                    class="btn btn-primary"
                                                    style="border-top: none !important;border-left: none !important;"
                                                    target="_blank">
                                                    {{'Download Quote' | translate }}</a>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <div class="PolicyPeriodInfo">

                                <div class="card" style="width:100%;" *ngIf="(prObj.HasComprehensive && prObj.productType=='5520') || (prObj.HasComprehensive && prObj.productType=='0000') ">
                                    <ul class="nav nav-tabs Sublistdata" role="tablist">
                                        <li role="presentation" class="active">
                                            <a href="#home" aria-controls="home" role="tab" data-toggle="tab">
                                                {{'Comprehensive Price in SAR'| translate}} </a>

                                        </li>

                                    </ul>
                                    <div class="tab-content">
                                        <div role="tabpanel" class="tab-pane active PolicyInfo Premium">

                                            <div class="CoversList">
                                                <label *ngFor="let tc of prObj.compCovers | compCoversPipe:true">
                                                    <span
                                                        class="lbltext">{{Lng=="en" ? tc.CoverDescription:tc.CoverDescription_Ar}}:</span>
                                                    <span>{{tc.GrossAmount | number : '1.2-2' }}</span>
                                                </label>


                                                <label>
                                                    <span class="lbltext"> {{'Gross Premium'| translate}}:</span>
                                                    <span>{{prObj.CompGrossPremium | number : '1.2-2'}}</span>

                                                </label>
                                                <label *ngIf="prObj.CompNCDPercentage>0">
                                                    <span class="lbltext"> {{'NCD'| translate}}:</span>
                                                    <span>{{prObj.CompNCDAmount | number : '1.2-2'}}({{prObj.CompNCDPercentage}}%)</span>

                                                </label>
                                                <label *ngIf="prObj.CompLDPercentage>0">
                                                    <span class="lbltext"> {{'LD'| translate}}:</span>
                                                    <span>{{prObj.CompLDAmount | number : '1.2-2'}}({{prObj.CompLDPercentage}}%)</span>

                                                </label>
                                                <label *ngIf="prObj.CompCrossSellDisPercent>0">
                                                    <span class="lbltext"> {{'CS Discount'| translate}}:</span>
                                                    <span>{{prObj.CompCrossSellDiscount | number : '1.2-2'}}({{prObj.CompCrossSellDisPercent}}%)</span>

                                                </label>
                           
                                                <label *ngIf="prObj.CompUserDiscountPer>0">
                                                    <span class="lbltext"> {{'Scheme Discount'| translate}}:</span>
                                                    <span>{{prObj.CompUserDiscountAmt | number : '1.2-2'}}({{prObj.CompUserDiscountPer}}%)</span>

                                                </label>

                                                <label *ngIf="prObj.CompDriverDiscPer>0">
                                                    <span class="lbltext">
                                                        {{'Female Driver Discount'| translate}}:</span>
                                                    <span>{{prObj.CompDriverDiscAmount | number : '1.2-2'}} ({{prObj.CompDriverDiscPer}}%)</span>

                                                </label>
                                                <label *ngIf="prObj.CompPromoPercent>0">
                                                    <span class="lbltext"> {{'Promo Discount'| translate}}:</span>
                                                    <span>{{prObj.CompPromoDiscount | number : '1.2-2'}}({{prObj.CompPromoPercent}}%)</span>

                                                </label>
                                                <label>
                                                    <span class="lbltext">
                                                        {{ 'Total(Excluding VAT)' | translate}}:</span>
                                                    <span>{{prObj.CompTotalPremiumBeforeVAT | number : '1.2-2'}}</span>

                                                </label>

                                                <label>
                                                    <span class="lbltext"> {{'VAT'| translate}}:</span>
                                                    <span>{{prObj.CompVAT_AMOUNT | number : '1.2-2'}}({{prObj.CompVAT_PERCENT}}%)</span>

                                                </label>

                                                <label *ngIf="prObj.COMP_UPR_VAT_AMOUNT>0">
                                                    <span class="lbltext"> {{'UPR VAT'| translate}}:</span>
                                                    <span>{{prObj.COMP_UPR_VAT_AMOUNT | number : '1.2-2'}}</span>

                                                </label>
                                                <label *ngIf="prObj.SurplusAmount>0">
                                                    <span class="lbltext"> {{'Surplus Amount'| translate}}:</span>
                                                    <span>{{prObj.SurplusAmount | number : '1.2-2'}}</span>
                                                </label>
                                                <label class="Total">
                                                    <span> {{'Total'| translate}}:</span>
                                                    <span>{{prObj.CompTotalPremium | number : '1.2-2'}}</span>

                                                </label>
                                            </div>

                                            <div class="btncomprehensivediv">

                                                <button class="btn btn-primary" data-toggle="modal"
                                                    data-target="#AdditionalCompCoversModal"
                                                    [disabled]="prObj.isPromoApply==true">{{'Add More Covers'| translate}}</button>
                                                <button class="btn btn-primary" name="btnCompProceed"
                                                    id="btnCompProceed"
                                                    (click)="goForComprehensive()">{{'Purchase'| translate}}</button>
                                                   
                                                    <!-- <button class="btn btn-primary" name="btnCompProceed"
                                                    id="btnCompProceed"
                                                    (click)="goForComprehensive()">{{'DownLoad Quote'| translate}}</button> -->

                                                    <a href="{{url.PrintURL}}MOTOR/ProposalDL.aspx?strParm={{prObj.DownLoadProposal_Comp}}:{{ProposalLan}}"
                                                    download="myPolicy"
                                                    class="btn btn-primary"
                                                    style="border-top: none !important;border-left: none !important;"
                                                    target="_blank">
                                                    {{'Download Quote' | translate }}</a>         
                                            </div>

                                            <div>
                                                <label class="lbltext">
                                                    {{'Coverage will include relatives (Parents, Spouse, Children, Brothers, and Sisters) or any driver who is under the sponsorship of the insured or registered on his/her payroll under official employment contract for all new/renewed policies effective 15/11/2023.'| translate}}   
                                                </label>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="row">

                        <div class="promo" *ngIf="(prObj.HasComprehensive || prObj.HasTPL)">
                            <div class="Field">
                                <div class="row">
                                    <div class="col-lg-10 col-md-10 col-sm-12 col-xs-12">
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <label class="lbltext"> {{'Do you have promo code?'| translate}}</label>
                                        </div>
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            
                                            <div class="col-lg-5 col-md-5 col-sm-8 col-xs-4">
                                                <input class="form-control" id="txtPromo" id="txtPromo"
                                                    placeholder="{{'Promo Code' | translate }}" type="text"
                                                    [(ngModel)]="prObj.PromoReq.PROMOCODE"
                                                    [disabled]="prObj.isPromoApply==true">
                                            </div>
                                            <div class="col-lg-2 col-md-3 col-sm-2 col-xs-2">
                                                <button class="btn btn-primary" (click)="ApplyMotorPromo()"
                                                    id="btnPromo" name="btnPromo"
                                                    [disabled]="(prObj.isPromoApply==true || prObj.PromoReq.PROMOCODE?.length==0 || prObj.PromoReq.PROMOCODE==null )">{{'Apply'| translate}}</button>
                                            </div>

                                            <div class="col-lg-5 col-md-3 col-sm-2 col-xs-6">
                                                <div>
                                                    <img  src="assets/img/Promo.png" class="promoimg">
                                                </div>
                                                <div>
                                                    <label class="lbltextPromo" data-toggle="modal" data-target="#Pomos"> {{'View Offers'| translate}}</label>
                                                </div>
                                                  
                                                   
                                            </div>

                                        </div>
                                    </div>
                                </div>

                             


                            </div>
                        </div>


                    </div>

                    <div class="row">
                        <hr class="hr" />
                    </div>



                </div>


            </div>
            <div class="row">
                <div class="ButtonActions ">
                    <div class="btn-group">
                        <button class="btn btn-primary btnPrev" name="btnPrev" id="btnPrev"
                            (click)="goPrev()">{{'Prev'| translate}}</button>
                        <button class="btn btn-primary btnNext" name="btnNext" id="btnNext" (click)="goNext()"
                            *ngIf="false">{{'Next'| translate}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



<div class="clears">

</div>

<!-- Additional TPL Covers -->
<div class="modal fade" id="AdditionalCoversModal" role="dialog" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

               <!-- <button type="button" class="close" data-dismiss="modal" >&times;</button> -->
                <h4 class="modal-title logins">{{'Additional TPL Covers'| translate}}</h4>
            </div>
            <div class="modal-body">

                <div class="ComprensivePremium">
                    <form #tplCoverForm="ngForm">
                        <table class="table table-striped tabledesign">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th>{{'Cover Description'| translate}} </th>
                                    <th style="min-width:130px">{{'Total Price'| translate}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let tplCover of prObj.tplCovers | tplManCovers:false;let i=index;">
                                    <td>
                                        <input name="{{tplCover.CoverCode}}" id="{{tplCover.CoverCode}}" type="checkbox" style="zoom:1.3"
                                            [(ngModel)]="tplCover.isSelected" [disabled]="tplCover.isman"
                                            (change)="calcPremium(tplCover.CoverCode)" />
                                    </td>
                                    <td>{{i+1}}</td>
                                    <td>{{ Lng=="en" ? tplCover.CoverDescription:tplCover.CoverDescription_Ar}}</td>
                                    <td>{{tplCover.GrossAmount | number : '1.2-2'}}</td>
                                </tr>
                            </tbody>
                        </table>


                        <div class="Actionsection">
                            <div class="Actions">
                                <div class="btn-group">
                                    <!--(click)="test()"-->
                                    <button type="button" class="btn btn-primary btns procced"
                                        data-dismiss="modal" (click)="AddAdditionalCovers('5515')">{{'Update Quote'| translate}}</button>

                                </div>
                            </div>
                        </div>
                    </form>

                </div>


            </div>

        </div>
    </div>

</div>
<!-- Additional TPL Covers -->

<!-- Additional Comp Covers -->
<div class="modal fade" id="AdditionalCompCoversModal" role="dialog" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <!-- <button type="button" class="close" data-dismiss="modal">&times;</button> -->
                <h4 class="modal-title logins">{{'Additional Comprehensive Covers'| translate}}</h4>
            </div>
            <div class="modal-body">
                <div class="ComprensivePremium">
                    <form #compForm="ngForm">
                        <table class="table table-striped tabledesign">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th>{{'Cover Description'| translate}} </th>
                                    <th style="min-width:130px">{{'Total Price'| translate}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let compCover of prObj.compCovers| compManCovers:false;let i=index;">
                                    <td>
                                        <input #txtCompCover name="{{compCover.CoverCode}}" id="{{compCover.CoverCode}}"
                                            type="checkbox" style="zoom:1.3" [(ngModel)]="compCover.isSelected"
                                            (change)="calCompPremium(compCover.CoverCode)" />
                                    </td>
                                    <td>{{i+1}}</td>
                                    <td>{{Lng=="en" ? compCover.CoverDescription:compCover.CoverDescription_Ar}}</td>
                                    <td>{{compCover.GrossAmount | number : '1.2-2'}}</td>
                                </tr>
                            </tbody>
                        </table>



                        <div class="Actionsection">
                            <div class="Actions">
                                <div class="btn-group">

                                    <button type="button" class="btn btn-primary btns procced"
                                        data-dismiss="modal" (click)="AddAdditionalCovers('5520')">{{'Update Quote'| translate}}</button>

                                </div>
                            </div>
                        </div>

                    </form>
                </div>


            </div>

        </div>
    </div>

</div>
<!---Additional Comp Covers-->




<!-- Promos Start-->
<div class="modal fade" id="Pomos" role="dialog"  >
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

              <button type="button" class="close" data-dismiss="modal" >&times;</button> 
                <h4 class="modal-title logins">{{'Promo Codes/ Offers'| translate}}</h4>
            </div>
            <div class="modal-body">

                <div class="ComprensivePremium">

                        <table class="table table-striped tabledesign">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>{{'Promotion Description'| translate}} </th>
                                    <th style="min-width:130px">{{'Promo Code'| translate}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let objPromo of bindObj.Promos;let i=index;">
                                    <td>{{i+1}}</td>
                                    <td>{{ Lng=="en" ? objPromo.PromoDesc:objPromo.ProdDescAr}}</td>
                                    <td>{{objPromo.Promocode}}</td>
                                </tr>
                            </tbody>
                        </table>
            

                </div>


            </div>

        </div>
    </div>

</div>
<!-- Promos End -->


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/PremiumInfo/PremiumInfo.html